/* eslint-disable react/prop-types */
import React from 'react'
import * as d3 from 'd3'
import { useChartOptions, useScales } from '../../../Context/ChartContext.tsx'

const defaultStrokeWidth = 4

export default function StrikeZoneFuzzyForeground() {
    const { settings } = useChartOptions()
    const { data } = settings

    const { xScale, yScale } = useScales()

    const [topMin, topMax] = d3.extent(data, (d) => d.szTop)
    const [botMin, botMax] = d3.extent(data, (d) => d.szBot)

    if (topMin === undefined || topMax === undefined) {
        console.warn('No data or no strike zone data')
        return null
    }
    if (botMin === undefined || botMax === undefined) {
        console.warn('No data or no strike zone data')
        return null
    }

    const height = yScale(botMax) - yScale(topMin)

    return (
        <g id="strikeZone">
            <line
                x1={xScale(-17 / 2 / 12) + defaultStrokeWidth / 2}
                y1={yScale(topMin)}
                x2={xScale(-17 / 2 / 12) + defaultStrokeWidth / 2}
                y2={yScale(topMin) + height}
                stroke="#111"
                strokeDasharray="8 2.5"
                strokeWidth={defaultStrokeWidth}
            />
            <line
                x1={xScale(17 / 2 / 12) - defaultStrokeWidth / 2}
                x2={xScale(17 / 2 / 12) - defaultStrokeWidth / 2}
                y1={yScale(topMin)}
                y2={yScale(topMin) + height}
                stroke="#111"
                strokeDasharray="8 2.5"
                strokeWidth={defaultStrokeWidth}
            />
        </g>
    )
}
